import { Injectable } from "@angular/core";

interface user {

  //////////////////
  //Initialization//
  //////////////////

  username: string;
  uid: string;
}

@Injectable()
export class UserService {
  private user: user;
  constructor() {}

  setUser(user: user) {
    this.user = user; //set the user values using the user interface as a template
  }

  getUID() {
    return this.user.uid; //return the user ID
  }
}
